export const FETCH_ALL = 'FETCH_ALL';
export const SET_ALL = 'SET_ALL';
export const SET_FETCH_ALL_ERROR = 'SET_FETCH_ALL_ERROR';